import styled from 'styled-components/macro'

export default styled.button`
  width: 100%;
  height: 48px;
  position: relative;
  background-color: ${props => props.buttonTheme.backgroundColor};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${props => props.theme.borderRadius};
  cursor: ${props => !props.loading && props.buttonTheme.cursor};
  user-select: none;
  font-size: ${props => props.theme.fontSize.text};
  font-weight: bold;
  color: ${props => props.buttonTheme.color};
  border: ${props => props.buttonTheme.border};
  outline: none;

  &:hover {
    border-color: ${props => !props.loading && props.buttonTheme.active};
  }

  &:active {
    background-color: ${props => !props.loading && props.buttonTheme.active};
  }

  @media screen and (max-width: 320px) {
    font-size: ${props => props.theme.fontSize.small};
  }
`

const marginSpace = 8
export const ButtonsContainer = styled.section`
  display: flex;
  width: 100%;
  direction: rtl;
  padding-top: ${props => props.hasTopPadding && props.theme.padding};
  margin-bottom: 1em;
  
  &>:first-child {
    margin-left: ${marginSpace / 2}px;
  }
    
  &>:last-child {
    margin-right: ${marginSpace / 2}px;
  }
`

export const ButtonScore = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`

export const PurchaseText = styled.div`
  text-align: center;
  width: 100%;
`
